import styles from "./GradingHeader.module.scss";
import { Device } from "../../DeviceSearch/types";
import DeviceIcon from "../../DeviceIcon/DeviceIcon";

type GradingHeaderProps = {
  device: Device;
};

export const GradingHeader = ({ device }: GradingHeaderProps) => {
  return (
    <div className={styles.gradingHeader}>
      <DeviceIcon category={device.category} />
      <div className={styles.gradingHeader__wrapper}>
        <p className={styles.gradingHeader__title}>Your device:</p>
        <p className={styles.gradingHeader__subtitle}>{device.description}</p>
      </div>
    </div>
  );
};
